import { render } from "./NewSession.vue?vue&type=template&id=4bfd8940&scoped=true"
import script from "./NewSession.vue?vue&type=script&lang=js"
export * from "./NewSession.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4bfd8940"

export default script